export const RESET_CONVERSATIONS = "RESET_CONVERSATIONS";
export const RESET_ERROR = "CONVERSATIONS_RESET_ERROR";
export const RESET_USER_FILTER = "RESET_USER_FILTER";

export const GET_CONVERSATIONS = "GET_CONVERSATIONS";
export const SET_CONVERSATIONS = "SET_CONVERSATIONS";

export const GET_AGENTS = "GET_AGENTS";
export const SET_AGENTS = "SET_AGENTS";

export const GET_ACTIVITY = "GET_ACTIVITY";
export const SET_ACTIVITY = "SET_ACTIVITY";

export const GET_SKILLS = "GET_SKILLS_MANAGER";
export const SET_SKILLS = "SET_SKILLS_MANAGER";

export const GET_TABS_BY_SKILL = "GET_TABS_BY_SKILL";
export const GET_TABS_BY_SKILL_LOADING = "GET_TABS_BY_SKILL_LOADING";
export const GET_TABS_BY_SKILL_SUCCESS = "GET_TABS_BY_SKILL_SUCCESS";
export const GET_TABS_BY_SKILL_ERROR = "GET_TABS_BY_SKILL_ERROR";

export const GET_CONVERSATIONS_FORM = "GET_CONVERSATIONS_FORM";
export const SET_CONVERSATIONS_FORM = "SET_CONVERSATIONS_FORM";

export const SET_CONVERSATIONS_FILTER = "SET_CONVERSATIONS_FILTER";
export const SET_GENERAL_FILTER = "SET_GENERAL_FILTER";

export const GET_USER_FILTER = "GET_USER_FILTER";
export const SET_USER_FILTER = "SET_USER_FILTER";
export const UPDATE_USER_FILTER = "UPDATE_USER_FILTERS";
export const UPDATE_USER_FILTER_SUCCESS = "UPDATE_FILTERS_SUCCESS";

export const API_ERROR = "CONVERSATIONS_API_ERROR";

export const RESET_MANAGER_PANEL = "RESET_MANAGER_PANEL";

export const HANDLE_LOGOUT_AGENT = "HANDLE_LOGOUT_AGENT";
export const HANDLE_LOGOUT_AGENT_CONFIRM = "HANDLE_LOGOUT_AGENT_CONFIRM";
export const HANDLE_LOGOUT_AGENT_SUCCESS = "HANDLE_LOGOUT_AGENT_SUCCESS";
export const HANDLE_LOGOUT_AGENT_ERROR = "HANDLE_LOGOUT_AGENT_ERROR";
